var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 7.5V1.875H1.875V7.5C0.839437 7.5 0 8.3395 0 9.375V29.0625C0 29.5802 0.41975 30 0.9375 30H31.0625C31.5802 30 32 29.5802 32 29.0625V9.375C32 8.3395 31.1606 7.5 30.125 7.5Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0625 0H0.9375C0.412437 0 0 0.412437 0 0.9375V9.375H32V0.9375C32 0.412437 31.5876 0 31.0625 0ZM10.375 5.625H4.75C4.22494 5.625 3.8125 5.21244 3.8125 4.6875C3.8125 4.16244 4.22494 3.75 4.75 3.75H10.375C10.9001 3.75 11.3125 4.16244 11.3125 4.6875C11.3125 5.21244 10.9001 5.625 10.375 5.625ZM27.25 5.625H16C15.4749 5.625 15.0625 5.21244 15.0625 4.6875C15.0625 4.16244 15.4749 3.75 16 3.75H27.25C27.7751 3.75 28.1875 4.16244 28.1875 4.6875C28.1875 5.21244 27.7751 5.625 27.25 5.625ZM25.375 11.25H6.625C6.10681 11.25 5.6875 11.6693 5.6875 12.1875V17.8125C5.6875 18.3307 6.10681 18.75 6.625 18.75H25.375C25.8932 18.75 26.3125 18.3307 26.3125 17.8125V12.1875C26.3125 11.6693 25.8932 11.25 25.375 11.25ZM14.125 20.625H6.625C6.10681 20.625 5.6875 21.0443 5.6875 21.5625C5.6875 22.0807 6.10681 22.5 6.625 22.5H14.125C14.6432 22.5 15.0625 22.0807 15.0625 21.5625C15.0625 21.0443 14.6432 20.625 14.125 20.625ZM14.125 24.375H6.625C6.10681 24.375 5.6875 24.7943 5.6875 25.3125C5.6875 25.8307 6.10681 26.25 6.625 26.25H14.125C14.6432 26.25 15.0625 25.8307 15.0625 25.3125C15.0625 24.7943 14.6432 24.375 14.125 24.375ZM25.375 24.375H17.875C17.3568 24.375 16.9375 24.7943 16.9375 25.3125C16.9375 25.8307 17.3568 26.25 17.875 26.25H25.375C25.8932 26.25 26.3125 25.8307 26.3125 25.3125C26.3125 24.7943 25.8932 24.375 25.375 24.375ZM25.375 20.625H17.875C17.3568 20.625 16.9375 21.0443 16.9375 21.5625C16.9375 22.0807 17.3568 22.5 17.875 22.5H25.375C25.8932 22.5 26.3125 22.0807 26.3125 21.5625C26.3125 21.0443 25.8932 20.625 25.375 20.625Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 30,
    x2: 16,
    y2: 1.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16,
    y1: 26.25,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D61DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D8DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.3980e847bd996548f2a68fcc707a5e79.svg";
export { ForwardRef as ReactComponent };